module.exports = __webpack_public_path__ + "static/media/logo-amazonas.d2b76584.png";